import { render, staticRenderFns } from "./instead-auth.vue?vue&type=template&id=2ffe71a5&scoped=true&"
import script from "./instead-auth.vue?vue&type=script&lang=js&"
export * from "./instead-auth.vue?vue&type=script&lang=js&"
import style0 from "./instead-auth.vue?vue&type=style&index=0&id=2ffe71a5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe71a5",
  null
  
)

export default component.exports